/**
 * Small shared pieces for document layouts: header-label editor and the who/when/why audit list.
 */
import React from 'react';
import { Input } from './ui/input';

export const LabelsEditor = ({ docType, fields, defaults, value, onChange, testIdPrefix = 'labels' }) => (
  <div className="grid grid-cols-2 md:grid-cols-3 gap-2" data-testid={`${testIdPrefix}-${docType}`}>
    {(fields || []).map((f) => (
      <div key={f.key}>
        <label className="text-[10px] uppercase tracking-wide text-slate-500">{f.label}</label>
        <Input
          value={(value || {})[f.key] ?? ''}
          placeholder={defaults?.[f.key] || ''}
          maxLength={40}
          onChange={(e) => {
            const next = { ...(value || {}) };
            if (e.target.value.trim() && e.target.value !== defaults?.[f.key]) next[f.key] = e.target.value; else delete next[f.key];
            onChange(next);
          }}
          className="h-8 text-sm"
          data-testid={`${testIdPrefix}-${docType}-${f.key}`}
        />
      </div>
    ))}
    <p className="col-span-full text-[11px] text-slate-500">Leave a field blank to keep the default shown in grey. Tax line labels come from your tax setup.</p>
  </div>
);

const ACTION_TEXT = {
  customer_update: 'updated', apply_preset: 'applied preset', company_update: 'changed company default',
  preset_saved: 'saved preset', preset_deleted: 'deleted preset',
};

export const DocumentAuditList = ({ items, emptyText = 'No changes recorded yet.', testIdPrefix = 'doc-audit' }) => {
  if (!items?.length) return <p className="text-xs text-slate-500" data-testid={`${testIdPrefix}-empty`}>{emptyText}</p>;
  return (
    <ul className="space-y-1.5 max-h-48 overflow-auto" data-testid={`${testIdPrefix}-list`}>
      {items.map((a) => (
        <li key={a.id} className="text-xs text-slate-200 border-b border-slate-700/50 pb-1.5 last:border-0" data-testid={`${testIdPrefix}-item-${a.id}`}>
          <span className="font-semibold">{a.actor_name || a.actor_email || 'Someone'}</span>{' '}
          <span className="text-slate-400">{ACTION_TEXT[a.action] || a.action}{a.preset_name ? ` “${a.preset_name}”` : ''}</span>
          {a.changes?.length > 0 && <span className="text-slate-300"> — {a.changes.join(', ')}</span>}
          {a.scope === 'customer' && a.customer_name && <span className="text-slate-500"> · {a.customer_name}</span>}
          <span className="text-slate-500 ml-2">{a.created_at ? new Date(a.created_at).toLocaleString() : ''}</span>
          {a.note && <div className="text-slate-400 italic mt-0.5">“{a.note}”</div>}
        </li>
      ))}
    </ul>
  );
};
